import moment from "moment/moment"
import LocalizedLink from "../../../hoc/LocalizedLink"
import Label from "../../Assets/Label/Label"
import clsx from "clsx"
import { IArticle, IProject } from "../../../types/content"
import { GetUserAvatar } from "../../Assets/GetUserAvatar/GetUserAvatar"
import { getLocale } from "../../../utils/getLocale"
import styles from "./ArticlePrevItem.module.scss"
import { useAppSelector } from "../../../hooks"
import { selectProjects } from "../../../redux/slice/main"

interface Props extends IArticle {
  isTags?: boolean
  isTarget?: boolean
  className?: string
}

const ArticlePrevItem = ({ text, name, created_at, id, creator, tags, isTags, isTarget, className }: Props) => {
  const projects = useAppSelector(selectProjects)

  const currentLang = getLocale()
  const currentProject = projects.filter((projectEl: IProject) => projectEl.isCurrent)[0]
  const currentProjectId = currentProject?.id

  return (
    <div className={clsx(styles.item, className)}>
      {creator && (
        <header className={styles.itemHeader}>
          <GetUserAvatar avatar={creator?.avatar_id} name={creator?.name} size={"xs"} />
          <div className={styles.info}>
            {creator.name}
            <p className={styles.date}>
              <span />
              {moment(created_at).locale(currentLang).format("DD MMMM")}
            </p>
          </div>
        </header>
      )}

      <LocalizedLink
        to={`/articles${currentProjectId ? "/" + currentProjectId : ""}/${id}`}
        isTarget={isTarget}
        className={styles.txt}
      >
        {name || text}
      </LocalizedLink>

      {isTags && tags && tags.length > 0 && (
        <div className={styles.tags}>
          {tags.map((item, index) => (
            <Label key={index} txt={item.name} mode={"gray"} />
          ))}
        </div>
      )}
    </div>
  )
}

export default ArticlePrevItem
